import { all, call, fork, put, takeEvery, takeLatest } from "redux-saga/effects";
import { BulkPaymentTypes, BulkPaymentApprovalPayload, BulkPaymentRejectPayload, BulkPaymentCheckPayload } from "./types";
import { callApiPost, callApiGet } from "../../utils/api";
import {
  bulkPaymentFailure,
  // bulkPaymentIncreaseStep,
  bulkPaymentSuccess,
  fileListSuccess,
  getFilesFailure,
  getFilesSuccess,
  getProviderSuccess,
  uploadFailure,
  uploadSuccess,
  submitToCheckerSuccess,
  submitToCheckerFailure,
  approveBulkPaymentSuccess,
  approveBulkPaymentFailure,
  rejectBulkPaymentSuccess,
  rejectBulkPaymentFailure,
  bulkPaymentCheckSuccess,
  bulkPaymentCheckFailure,
  downloadSampleFileSuccess,
  downloadSampleFileFailure,
  bulkPaymentExportRequest,
  bulkPaymentExportSuccess,
  bulkPaymentExportFailure,
} from "./actions";
import { path } from "../../helpers/path";
import { logout } from "../auth";
import { BulkPayload } from "../../interfaces/BulkPayment";
import { BulkPaymentExportPayload } from "./types";

function* getProviders(): any {
  try {
    const res = yield call(callApiGet, "payments/getmobilewalletproviders");
    const newres = res.data.map((item: any, name: any) => {
      name = "name";
      return { [name]: item };
    });
    yield put(getProviderSuccess(newres));
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        localStorage.removeItem("user");
        localStorage.removeItem("persist:root");
        localStorage.clear();
        window.location.href = path.login;
      } else {
        //yield put(getProvidersFailure('An error occured during payment.'))
      }
    } else {
      throw err;
    }
  }
}

function* uploadFile({ payload }: { type: string; payload: FormData }): any {
  try {
    const res = yield call(callApiPost, "payments/bulk/importfile", payload);
    yield put(uploadSuccess(res.data));

    // yield put(bulkPaymentIncreaseStep(1));
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        localStorage.removeItem("user");
        localStorage.removeItem("persist:root");
        localStorage.clear();
        window.location.href = path.login;
      } else {
        yield put(uploadFailure(err.response.data));
      }
    } else {
      yield put(
        uploadFailure("An error occured when making request to server")
      );
    }
  }
}

function* uploadedFilePreview({
  payload,
}: {
  type: string;
  payload: number;
}): any {
  try {
    const res = yield call(callApiGet, `payments/bulk/filepreview/${payload}`);
    yield put(fileListSuccess(res.data));
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        localStorage.removeItem("user");
        localStorage.removeItem("persist:root");
        localStorage.clear();
        window.location.href = path.login;
      } else {
        yield put(uploadFailure(err.response.data));
      }
    } else {
      yield put(uploadFailure("An unknwon error occurred"));
    }
  }
}

function* bulkPaymentRequest({
  payload,
}: {
  type: string;
  payload: BulkPayload;
}): any {
  try {
    const res = yield call(
      callApiPost,
      `payments/updatepaymentstatuses?fileId=${payload.fileId}&approvalStatus=${payload.approvalStatus}`,
      payload
    );
    // yield put(bulkPaymentIncreaseStep(1));
    yield put(bulkPaymentSuccess(res.data));
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        localStorage.removeItem("user");
        localStorage.removeItem("persist:root");
        localStorage.clear();
        window.location.href = path.login;
      } else {
        yield put(bulkPaymentFailure(err.response.data));
      }
    } else {
      yield put(
        bulkPaymentFailure("An error occured when making request to server")
      );
    }
  }
}

function* getPaymentFiles({ payload }: { type: string; payload: any }): any {
  try {
    const pageSize = payload.pageSize;
    const skip = payload.skip;
    const res = yield call(callApiGet, `payments/bulk/getfiles/${pageSize}/${skip}`);
    if (res.status === 200) {
      const files = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.bulkfiles)
        ? res.data.bulkfiles
        : Array.isArray(res.data?.item2)
        ? res.data.item2
        : Array.isArray(res.data?.records)
        ? res.data.records
        : Array.isArray(res.data?.data)
        ? res.data.data
        : [];
      const total = Number(res.data?.totalRecords || res.data?.item1 || files.length);
      yield put(getFilesSuccess({ files, total }));
    }
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        localStorage.removeItem("user");
        localStorage.removeItem("persist:root");
        localStorage.clear();
        window.location.href = path.login;
      } else {
        yield put(getFilesFailure(err.response.data));
      }
    } else {
      yield put(getFilesFailure("An unknwon error occurred"));
    }
  }
}

function* submitToChecker({ payload }: { type: string; payload: number }): any {
  try {
    const res = yield call(
      callApiPost,
      `payments/bulk/submittochecker?fileId=${payload}`,
      {}
    );
    yield put(submitToCheckerSuccess(res.data));
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        localStorage.removeItem("user");
        localStorage.removeItem("persist:root");
        localStorage.clear();
        window.location.href = path.login;
      } else {
        yield put(submitToCheckerFailure(err.response.data));
      }
    } else {
      yield put(
        submitToCheckerFailure("An error occurred when making request to server")
      );
    }
  }
}

function* approveBulkPayment({ payload }: { type: string; payload: BulkPaymentApprovalPayload }): any {
  try {
    const config = {
      headers: {
        CheckerId: payload.email,
        CheckerKey: payload.otp,
      },
    };

    const res = yield call(
      callApiPost,
      `payments/bulk/approvepayment?fileId=${payload.fileId}`,
      {},
      config
    );

    yield put(approveBulkPaymentSuccess(res.data));
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        localStorage.removeItem("user");
        localStorage.removeItem("persist:root");
        localStorage.clear();
        window.location.href = path.login;
      } else {
        yield put(approveBulkPaymentFailure(err.response.data));
      }
    } else {
      yield put(
        approveBulkPaymentFailure("An error occurred when making request to server")
      );
    }
  }
}

function* rejectBulkPayment({ payload }: { type: string; payload: BulkPaymentRejectPayload }): any {
  try {
    const config = {
      headers: {
        CheckerId: payload.email,
        CheckerKey: payload.otp,
      },
    };

    const res = yield call(
      callApiPost,
      `payments/bulk/rejectpayment?fileId=${payload.fileId}`,
      {},
      config
    );

    yield put(rejectBulkPaymentSuccess(res.data));
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        localStorage.removeItem("user");
        localStorage.removeItem("persist:root");
        localStorage.clear();
        window.location.href = path.login;
      } else {
        yield put(rejectBulkPaymentFailure(err.response.data));
      }
    } else {
      yield put(
        rejectBulkPaymentFailure("An error occurred when making request to server")
      );
    }
  }
}

function* bulkPaymentCheck({ payload }: { type: string; payload: BulkPaymentCheckPayload }): any {
  try {
    const config = {
      headers: {
        CheckerId: payload.email,
        CheckerKey: payload.otp,
      },
    };
    const res = yield call(() => callApiGet(`payments/bulk/filecheck/${payload.fileId}`, config));
    yield put(bulkPaymentCheckSuccess(res.data));
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        localStorage.removeItem("user");
        localStorage.removeItem("persist:root");
        localStorage.clear();
        window.location.href = path.login;
      } else {
        yield put(bulkPaymentCheckFailure(err.response.data));
      }
    } else {
      yield put(bulkPaymentCheckFailure("An error occurred when making request to server"));
    }
  }
}

function* downloadSampleFileSaga({ type }: { type: string }): any {
  try {
    const res = yield call(callApiGet, "payments/bulk/getsamplefile");

    if (res.data && res.data.fileContents) {
      const { fileContents, contentType, fileDownloadName } = res.data;

      const binaryString = window.atob(fileContents);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([bytes], {
        type: contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileDownloadName || 'BulkSampleFile.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      yield put(downloadSampleFileSuccess());
    } else {
      throw new Error('Invalid response format - missing fileContents');
    }
  } catch (err: any) {
    console.error('Download sample file error:', err);
    yield put(downloadSampleFileFailure(err.message || 'Download failed'));
  }
}

function* exportBulkPayment({ payload }: { type: string; payload: BulkPaymentExportPayload }): any {
  try {
    const config = {
      headers: {
        CheckerId: payload.email,
        CheckerKey: payload.otp,
      },
      responseType: 'blob',
    };
    const res = yield call(callApiGet, `payments/bulk/filecheckexport/${payload.fileId}`, config);
    // Download the file (CSV)
    const blob = new Blob([res.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    // Try to get filename from response headers, fallback to default
    const contentDisposition = res.headers['content-disposition'];
    let fileName = 'BulkPaymentExport.csv';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^";]+)"?/);
      if (match && match[1]) fileName = match[1];
    }
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    yield put(bulkPaymentExportSuccess());
  } catch (err: any) {
    yield put(bulkPaymentExportFailure(err.message || 'Export failed'));
  }
}

function* watchUploadFile() {
  yield takeEvery(BulkPaymentTypes.UPLOAD_FILE, uploadFile);
}
function* watchUploadedFilePreview() {
  yield takeEvery(BulkPaymentTypes.FILE_PREVIEW_REQUEST, uploadedFilePreview);
}

function* watchFetchProviders() {
  yield takeEvery(BulkPaymentTypes.GET_PROVIDERS, getProviders);
}

function* watchBulkPaymentRequest() {
  yield takeEvery(
    BulkPaymentTypes.COMPLETE_PAYMENT_REQUEST,
    bulkPaymentRequest
  );
}

function* watchGetPaymentFiles() {
  yield takeEvery(
    BulkPaymentTypes.GET_BULKPAYMENT_FILES_REQUEST,
    getPaymentFiles
  );
}

function* watchSubmitToChecker() {
  yield takeLatest(BulkPaymentTypes.SUBMIT_TO_CHECKER_REQUEST, submitToChecker);
}

function* watchApproveBulkPayment() {
  yield takeLatest(BulkPaymentTypes.APPROVE_BULK_PAYMENT_REQUEST, approveBulkPayment);
}

function* watchRejectBulkPayment() {
  yield takeEvery(BulkPaymentTypes.REJECT_BULK_PAYMENT_REQUEST, rejectBulkPayment);
}

function* watchBulkPaymentCheck() {
  yield takeLatest(BulkPaymentTypes.BULK_PAYMENT_CHECK_REQUEST, bulkPaymentCheck);
}

function* watchDownloadSampleFile() {
  yield takeLatest(BulkPaymentTypes.DOWNLOAD_SAMPLE_FILE_REQUEST, downloadSampleFileSaga);
}

function* watchBulkPaymentExport() {
  yield takeLatest(BulkPaymentTypes.BULK_PAYMENT_EXPORT_REQUEST, exportBulkPayment);
}

export function* bulkPaymentSaga() {
  yield all([
    fork(watchUploadFile),
    fork(watchUploadedFilePreview),
    fork(watchFetchProviders),
    fork(watchBulkPaymentRequest),
    fork(watchGetPaymentFiles),
    fork(watchSubmitToChecker),
    fork(watchApproveBulkPayment),
    fork(watchRejectBulkPayment),
    fork(watchBulkPaymentCheck),
    fork(watchDownloadSampleFile),
    fork(watchBulkPaymentExport),
  ]);
}
